import { render, staticRenderFns } from "./AI-rewrite.vue?vue&type=template&id=66dc2429&scoped=true&"
import script from "./AI-rewrite.ts?vue&type=script&lang=js&"
export * from "./AI-rewrite.ts?vue&type=script&lang=js&"
import style0 from "./AI-rewrite.less?vue&type=style&index=0&id=66dc2429&lang=less&scoped=true&"
import style1 from "./AI-rewrite.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc2429",
  null
  
)

export default component.exports